import Vue from 'vue'
import Vuex from 'Vuex'
import router from '../router'

Vue.use(Vuex)
const Home = {
  namespaced: true,
  state: {
    title: 'Welcome to Kyohei Portfolio Site',
    vueLogo: require('@/assets/vue_logo.png')
  },
  getters: {
    getTitle(state) {
      return state.title
    },
    getVueLogo(state) {
      return state.vueLogo
    }
  }
}
const PageTitle = {
  namespaced: true,
  state: {
    title: ['Home', 'About', 'Works', 'Contact']
  },
  mutations: {},
  actions: {},
  getters: {
    getTitle(state, getters, rootState) {
      return state.title[rootState.pageNum]
    }
  }
}

const About = {
  namespaced: true,
  state: {
    title: 'About',
    nickname: '齋藤 恭兵',
    name: 'kyoppii(きょっぴ)',
    profileImage: require('@/assets/profile.png'),
    biography: [
      {
        year: '2016',
        month: '03',
        title: '鶴岡工業高等専門学校(山形) 制御情報工学科 卒業'
      },
      {
        year: '2016',
        month: '04',
        title: '千葉大学 工学部 情報画像学科 入学'
      },
      {
        year: '2018',
        month: '03',
        title: '千葉大学 工学部 情報画像学科 卒業'
      },
      {
        year: '2020',
        month: '03',
        title: '千葉大学大学院 融合理工学府 数学情報科学専攻 修了'
      },
      {
        year: '2020',
        month: '04',
        title: '株式会社ZOZOテクノロジーズ 入社'
      }
    ],
    // skills: {
    //   Backend: {
    //     title: 'Backend',
    //     skill: [
    //       {
    //         name: 'Django',
    //         year: true,
    //         date: 1,
    //         rate: 3
    //       },
    //       {
    //         name: 'Ruby on Rails',
    //         year: true,
    //         date: 1,
    //         rate: 2
    //       },
    //       {
    //         name: 'Scala',
    //         year: false,
    //         date: 2,
    //         rate: 1
    //       }
    //     ]
    //   },
    //   Frontend: {
    //     title: 'Frontend',
    //     skill: [
    //       {
    //         name: 'HTML・CSS',
    //         year: true,
    //         date: 2,
    //         rate: 3
    //       },
    //       {
    //         name: 'Javascript',
    //         year: true,
    //         date: 1,
    //         rate: 2
    //       },
    //       {
    //         name: 'Vue.js',
    //         year: false,
    //         date: 1,
    //         rate: 1
    //       }
    //     ]
    //   },
    //   MachineLearning: {
    //     title: 'ML・DL',
    //     skill: [
    //       {
    //         name: 'Python',
    //         year: true,
    //         date: 2,
    //         rate: 4
    //       },
    //       {
    //         name: 'Keras',
    //         year: true,
    //         date: 1,
    //         rate: 3
    //       },
    //       {
    //         name: 'Pandas',
    //         year: false,
    //         date: 5,
    //         rate: 2
    //       },
    //       {
    //         name: 'Scikit-learn',
    //         year: false,
    //         date: 3,
    //         rate: 2
    //       },
    //       {
    //         name: 'Tensorflow',
    //         year: false,
    //         date: 1,
    //         rate: 1
    //       }
    //     ]
    //   },
    //   DataBase: {
    //     title: 'DB・Server',
    //     skill: [
    //       {
    //         name: 'MySQL',
    //         year: true,
    //         date: 1,
    //         rate: 3
    //       },
    //       {
    //         name: 'PostgreSQL',
    //         year: true,
    //         date: 1,
    //         rate: 3
    //       },
    //       {
    //         name: 'AWS(EC2, RDB)',
    //         year: true,
    //         date: 1,
    //         rate: 3
    //       },
    //       {
    //         name: 'GCP',
    //         year: false,
    //         date: 5,
    //         rate: 2
    //       }
    //     ]
    //   }
    // },
    hackathon: [
      {
        title: 'MICHIKUSA',
        date: '2018/03',
        competition: '第1回 東京公共交通オープンデータチャレンジ',
        award: 'INIAD特別賞'
      },
      {
        title: 'クーポンマシマシ',
        date: '2018/06',
        competition: '第3回 ジロッカソン',
        award: '優勝'
      },
      {
        title: '日報スカウター',
        date: '2018/08',
        competition: 'Hack U 2018 TOKYO',
        award: null
      },
      {
        title: 'ばえるーポン',
        date: '2018/12',
        competition: 'JP HACKS 2018',
        award: '準優勝'
      }
    ],
    qualification: ['応用情報技術者', 'FP3級']
  },
  getters: {
    getName(state) {
      return state.name
    },
    getNickname(state) {
      return state.nickname
    },
    getBiography(state) {
      return state.biography
    },
    getSkills(state) {
      return state.skills
    },
    getHackathon(state) {
      return state.hackathon
    },
    getTitle(state) {
      return state.title
    },
    getProfileImg(state) {
      return state.profileImage
    },
    getQualification(state) {
      return state.qualification
    }
  }
}

const Works = {
  namespaced: true,
  state: {
    title: 'Works',
    isShowModal: false,
    modalIndex: 0,
    switchModal: '',
    intern: [
      {
        title: '株式会社ライトワークス',
        WorkImg: require('@/assets/lw_logo.png'),
        skills: ['C#', 'Ranorex', 'GCP'],
        isLong: true,
        description:
          '自動回帰テスト, サーバログ監視システム開発, 技術検証(DeepLearning)',
        date: '2017/04 ~ 2017/12'
      },
      {
        title: '株式会社ディップ',
        WorkImg: require('@/assets/dip_logo.png'),
        skills: ['Python', 'Django'],
        isLong: true,
        description:
          '深層学習を用いた仮想通貨価格予測, 求人情報クローラ開発, SNS求人システム開発',
        date: '2017/12 ~ Now'
      },
      {
        title: '合同会社DMM.com',
        WorkImg: require('@/assets/dmm_logo.png'),
        skills: ['Python', 'AWS'],
        isLong: false,
        description: '総合トップページの改修',
        date: '2018/08 (1month)'
      },
      {
        title: '株式会社ネクストビート',
        WorkImg: require('@/assets/nextbeat_logo.png'),
        skills: ['Scala', 'Play'],
        isLong: false,
        description: 'Webアプリケーション開発',
        date: '2018/09 (2weeks)'
      },
      {
        title: '株式会社サイバーエージェント',
        WorkImg: require('@/assets/ca_logo.png'),
        skills: ['Scala'],
        isLong: false,
        description: '広告レコメンドエンジンの開発',
        date: '2018/09 ~ 2018/10 (1month)'
      },
      {
        title: '株式会社サイバーエージェント',
        WorkImg: require('@/assets/ca_logo.png'),
        skills: ['Python'],
        isLong: false,
        description: '広告インプレッション数予測',
        date: '2018/12 (1month)'
      },
      {
        title: 'Repro Inc',
        WorkImg: require('@/assets/repro_logo.png'),
        skills: ['Python', 'BQ'],
        isLong: true,
        description: 'チャーン予測, 市場調査',
        date: '2019/6 ~'
      }
    ],
    apps: [
      {
        title: 'MICHIKUSA',
        WorkImg: require('@/assets/michikusa.png'),
        skills: ['Ruby on Rails', 'Python'],
        description:
          '機械学習を用いたレコメンドシステム．Twitterから集めたツイートをもとに観光地のおすすめ度を機械学習により計算',
        date: '2018/05',
        links: {
          'APP PAGE': 'https://ai-event-crawler.herokuapp.com/',
          YOUTUBE: 'https://youtu.be/oNtmaN4SQ9g'
        }
      },
      {
        title: 'AIイベントカレンダー',
        WorkImg: require('@/assets/ai_event_calendar.png'),
        skills: ['Django', 'Python'],
        description:
          'AI系イベントを効率よく収集するために作成．クローリングして集めたデータを一覧で表示，テキストデータによる出力も行っている．',
        date: '2018/04',
        links: false
      },
      {
        title: 'クーポンマシマシ',
        WorkImg: require('@/assets/coupon_mashimashi.png'),
        skills: ['Ruby on Rails', 'Python'],
        description:
          'SNSに投稿されたラーメン二郎の画像をAIで分析．二郎っぽいほど割引額の高いクーポンを発行．',
        date: '2018/06',
        links: {
          github: 'https://github.com/Kyou13/JiroHack'
        }
      },
      {
        title: '日報スカウター',
        WorkImg: require('@/assets/nippo_scouter.png'),
        skills: ['Ruby on Rails', 'Python'],
        description:
          '日報の内容をAIで評価するSNS風アプリ。日報の新たな可能性を提案した．',
        date: '2018/08',
        links: {
          github: 'https://github.com/Kyou13/JiroHack'
        }
      },
      {
        title: 'ばえるーポン',
        WorkImg: require('@/assets/baerupon.png'),
        skills: ['Ruby on Rails', 'Python'],
        description:
          'SNSに投稿された画像をAIで分析．写真のクオリティによってクーポンの割引率を決定し，発行する．',
        date: '2018/12',
        links: {
          'RESULT PAGE': 'https://2018.jphacks.com/result/',
          YOUTUBE: 'https://youtu.be/5-lMbg_ud0s'
        }
      }
    ]
  },
  mutations: {
    show(state) {
      state.isShowModal = true
    },
    hide(state) {
      state.isShowModal = false
    },
    setIndex(state, index) {
      state.modalIndex = index
    },
    setModalIndex(state, index) {
      state.switchModal = index
    }
  },
  actions: {
    showAppModal({ commit }, index) {
      commit('setIndex', index)
      commit('setModalIndex', 0)
      commit('show')
    },
    showInternModal({ commit }, index) {
      commit('setIndex', index)
      commit('setModalIndex', 1)
      commit('show')
    },
    hideModal({ commit }) {
      commit('hide')
    }
  },
  getters: {
    getAllApp(state) {
      return state.apps
    },
    getAllIntern(state) {
      return state.intern
    },
    getApp: state => index => {
      return state.apps[index]
    },
    getIntern: state => index => {
      return state.intern[index]
    },
    getTitle(state) {
      return state.title
    },
    getShowModal(state) {
      return state.isShowModal
    },
    getModal(state) {
      if (state.switchModal === 0) {
        return state.apps[state.modalIndex]
      } else {
        return state.intern[state.modalIndex]
      }
    }
  }
}

const Contact = {
  namespaced: true,
  state: {
    title: 'Contact',
    accounts: [
      {
        isStackActive: false,
        link: 'https://github.com/Kyou13',
        icon: [
          {
            prefix: 'fab',
            iconName: 'github-square',
            className: 'fa-2x'
          }
        ]
      },
      {
        isStackActive: false,
        link: 'https://www.facebook.com/kyohei.saito.77',
        icon: [
          {
            prefix: 'fab',
            iconName: 'facebook',
            className: 'fa-2x'
          }
        ]
      },
      {
        isStackActive: false,
        link: 'https://www.instagram.com/kyoppygraphy/',
        icon: [
          {
            prefix: 'fab',
            iconName: 'instagram',
            className: 'fa-2x'
          }
        ]
      },
      {
        isStackActive: true,
        link: 'https://qiita.com/Kyou13',
        icon: [
          {
            prefix: 'fas',
            iconName: 'square',
            className: 'fa-stack-2x'
          },
          {
            prefix: 'fas',
            iconName: 'search',
            className: 'fa-stack-1x fa-inverse fa-2x'
          }
        ]
      }
    ]
  },
  getters: {
    getTitle(state) {
      return state.title
    },
    getAccounts(state) {
      return state.accounts
    }
  }
}

export default new Vuex.Store({
  state: {
    pageNum: 0
  },
  mutations: {
    updatePageNum(state, value) {
      state.pageNum = value.pageNum
    }
  },
  actions: {
    tabAction({ commit }, pageNum) {
      commit('updatePageNum', { pageNum })
    }
  },
  modules: {
    Home,
    PageTitle,
    About,
    Works,
    Contact
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js